import { lazy } from "react";

export const FourOhFour = lazy(() => import("./FourOhFour/FourOhFour"));
export const FourOhThree = lazy(() => import("./FourOhThree/FourOhThree"));
export const StatusPage = lazy(() => import("./StatusPage/StatusPage"));
